import { connect } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";

import { ApplicationState } from "../../../redux/ApplicationState";
import { resetStates } from "../../../actions/Common";
import { filterOperatorServiceList, getListResult } from "../../../utils";
import { AgencyListPayload } from "../../../models/ProviderMaterials";
import ReferralRequestTab from "../components/PriorAuthTabs";
import { getMasterServiceProvider, getSendCommunicationAuthType } from "../../../actions/Master";
import { documentDownload, ingestProcess, postDocumentReview, postPriorAuthSubmit, uploadDocumentFile } from "../../../actions/ReferralAction";
import { AuthorizationPayload, DocumentReviewPayload } from "../../../models/Referral";
import { UserPageTrack } from "../../../models/User";
import { postUserPageTrack } from "../../../actions/UserAction";
import { Numbers } from "../../../constants/Referral";
import { GetPatientInformationPayload } from "../../../models/Patient";
import { patientInformationById } from "../../../actions/Patient";

const mapStateToProps = ({
  loggedInUserState,
  masterServiceProviderState,
  masterSendCommunicationAuthTypeState,
  masterReferralSourceState,
  patientFromMbiState,
  memberInfoDataState,
  masterCareTypeState,
  disciplineListState,
  ingestProcessState,
  priorAuthSubmitState,
  documentUploadState,
  patientInformationByIdState,
  isRetroDetailsState,
  documentDownloadState,
  documentReviewState,
  informationState
}: ApplicationState) => ({
  loggedInUser: loggedInUserState.response,
  masterServiceProviderState: getListResult(
    filterOperatorServiceList(
      masterServiceProviderState.response,
      true,
      loggedInUserState.response
    )
  ),
  serviceProviderListWithDetails: masterServiceProviderState.response,
  masterSendCommunicationAuthTypeState: getListResult(
    masterSendCommunicationAuthTypeState.response
  ),
  masterReferralSourceState: getListResult(masterReferralSourceState.response),
  patientFromMbiState: patientFromMbiState.response,
  memberInfoDataState: memberInfoDataState.response,
  masterCareTypeState: getListResult(masterCareTypeState.response),
  disciplineListState: disciplineListState.response,
  ingestProcessState: ingestProcessState.response,
  ingestProcessErrorState: ingestProcessState.error,
  priorAuthSubmitState: priorAuthSubmitState.response,
  priorAuthSubmitErrorState: priorAuthSubmitState.error,
  documentUploadErrorState: documentUploadState.error,
  documentUploadState: documentUploadState.response,
  patientInformationByIdState: patientInformationByIdState.response,
  isRetroDetailsState: isRetroDetailsState.response,
  documentDownloadData: documentDownloadState,
  documentReviewListData: documentReviewState.response,
  informationState: informationState.response,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    resetStates: (actionType: string, field?: string) => {
      dispatch(resetStates(actionType, field));
    },
    getMasterServiceProvider: (payload: AgencyListPayload) => {
      dispatch(getMasterServiceProvider(payload));
    },
    getSendCommunicationAuthType: () => {
      dispatch(getSendCommunicationAuthType());
    },
    ingestProcess: (payload: any) => {
      dispatch(ingestProcess(payload));
    },
    postPriorAuthSubmit: (payload: AuthorizationPayload) => {
      dispatch(postPriorAuthSubmit(payload));
    },
    postUserPageTrack: (payload: UserPageTrack) => {
      dispatch(postUserPageTrack(payload));
    },
    uploadDocumentFile: (payload: any) => {
      dispatch(uploadDocumentFile(payload));
    },
    getDocumentByBlob: (blobId: number) => {
      dispatch(documentDownload(blobId, Numbers.TWO));
    },
    postDocumentReview: (payload: DocumentReviewPayload) => {
      dispatch(postDocumentReview(payload, Numbers.TWO));
    },
    getPatientInformationById: (payload: GetPatientInformationPayload) => {
      dispatch(patientInformationById(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReferralRequestTab);